import { Injectable } from '@angular/core';
import { ModalMessagerService } from '../modal-messager/modal-messager.service';
import { SLLayer } from '../model/sl-layer';
import { SlWapiService } from '../model/api-services/sl-wapi.service';

@Injectable({
	providedIn: 'root'
})
export class KmlExportService {

	constructor(private wapi: SlWapiService) {
	}
	ExportKMZ(messager: ModalMessagerService,
		fileName: string,
		layer: SLLayer,
		cols: Array<string>, data: Array<any> | '*', rawMode: boolean = false) {
		const fields = [];
		const nonCols = ['_checkbox_selector','_sl_actions']
		const exportable = layer.GetExportableAttributes(true);
		for(const col of cols) {
			if(nonCols.indexOf(col) > -1) {
				continue;
			}
			if (exportable.indexOf(col) === -1) {
				continue;
			}
			fields.push(col);
		}
		const gids: string = data === '*' ? '*' : SLLayer.GetGids(data, true) as string;
		const params: any = {
			gids: (gids),
			fields: (fields)
		}
		if (layer.isPLayer === true) {
			params.plid = layer.plid;
		} else {
			params.lid = layer.id;
		}
		params.labelitem = layer.labelAttribute;
		messager.RequestDownload(
				{
					extension: 'kmz', 
					mimeType: 'application/vnd',
					defaultFileName: 'ResultsFrom_' + layer.name.replace(/ /g, '_')
				},
				'layers/download/kml/',
				params,
				'Export results for Google Earth '
		);
		// this.wapi.DownloadFile('layers/download/kml/', params, 'application/vnd', fileName);
	}
}
